var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useRef, useEffect, useImperativeHandle, useCallback } from 'react';
import ReactDOM from 'react-dom';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import outlierAnimation from './animation.json';
import styles from './loading.module.scss';
var rendererSettings = {
    preserveAspectRatio: 'xMidYMid slice'
};
var Loading = React.forwardRef(function (_a, ref) {
    var animationData = _a.animationData, className = _a.className, defaultActive = _a.active, size = _a.size, speed = _a.speed;
    var _b = useState(false), active = _b[0], setActive = _b[1];
    var element = useRef(null);
    var wrapper = useRef();
    var timeout = useRef();
    var setOpened = useCallback(function (value) {
        if (value === active)
            return;
        if (!value) {
            if (timeout.current !== void 0)
                return;
            element.current && element.current.classList.add(styles.closed);
            timeout.current = setTimeout(function () {
                setActive(false);
                timeout.current = void 0;
            }, 300);
        }
        else {
            setActive(true);
        }
    }, [active]);
    useEffect(function () {
        var loadingContainer = document.getElementById('loading-container');
        if (!loadingContainer) {
            loadingContainer = document.createElement('div');
            loadingContainer.setAttribute('id', 'loading-container');
            document.body.prepend(loadingContainer);
        }
        wrapper.current = loadingContainer;
    }, []);
    useEffect(function () {
        setOpened(defaultActive);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultActive]);
    useImperativeHandle(ref, function () { return ({
        active: active,
        setActive: setOpened
    }); });
    if (!active || !wrapper.current)
        return null;
    var clName = "".concat(styles.loading, " ").concat(className).trim();
    return ReactDOM.createPortal((_jsx("div", __assign({ ref: element, className: clName }, { children: _jsx(Lottie, { speed: speed, rendererSettings: rendererSettings, loop: true, play: true, animationData: animationData, style: { width: size, height: size } }, void 0) }), void 0)), wrapper.current);
});
Loading.defaultProps = {
    animationData: outlierAnimation,
    className: '',
    active: false,
    size: 400
};
export default Loading;
